import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(14, 0, 14, 0),
  background: `linear-gradient(
      0deg,
      ${theme.palette.background.primary} 24.16%,
      ${alpha(theme.palette.background.primary, 0)} 100%
    )`,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  '& .ORUTVPromoContainer': {
    position: 'relative',
    zIndex: 1,
  },
  '& .ORUTVBGPattern': {
    position: 'absolute',
    inset: 0,
    zIndex: 0,
    pointerEvents: 'none',
    maskImage: `linear-gradient(
        to bottom,
         ${alpha(theme.palette.background.primary, 0.7)} 0%,
         ${alpha(theme.palette.background.primary, 0)} 100%
      )`,
  },
  '& .ORUTVPromoContentStack': {
    position: 'relative',
    alignItems: 'flex-start',
    zIndex: 2,
    gap: theme.spacing(4),
  },
  '& .ORUTVPromoContentGridItem': {
    order: 2,
    [theme.breakpoints.up('lg')]: {
      order: 1,
    },
  },
  '& .ORUTVPromoImageGridItem': {
    order: 1,
    [theme.breakpoints.up('lg')]: {
      order: 2,
    },
  },
  '& .ORUTVRideDuration': {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(0.25),
  },
  '& .ORUTVPromoDatesBlock': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  '& .ORUTVPromoDatesInner': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
  },
  '& .ORUTVPromoDatesRow': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
  },
  '& .ORUTVPromoDatesRowIcon': {
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.primary.main,
  },
  '& .ORUTVPromoDateChips': {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginLeft: theme.spacing(4),
  },
  '& .ORUTVPromoDateChip': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(0.5),
    backgroundColor: alpha(theme.palette.common.white, 0.1),
  },
  '& .ORUTVPromoDateChipLabel': {
    fontWeight: 500,
    color: theme.palette.text.secondary,
    lineHeight: '100%',
  },
  '& .ORUTVPromoSpotsLimited': {
    fontWeight: 600,
    fontStyle: 'italic',
  },
  '& .ORUTVPromoBookBtn': {
    minWidth: theme.typography.pxToRem(250),
    [theme.breakpoints.down('md')]: {
      width: '100%',
      minWidth: 0,
    },
  },
  '& .ORUTVPromoImage': {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    height: theme.typography.pxToRem(600),
    maxWidth: '100%',
    isolation: 'isolate',
    '& .IBimgbox': {
      borderRadius: theme.spacing(1),
    },
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(450),
    },
    [theme.breakpoints.down('md')]: {
      height: theme.typography.pxToRem(300),
    },
  },
}));

export default StyledBox;
